// import AirDatepicker from 'air-datepicker';
// import localeNl from 'air-datepicker/locale/nl';
// import localeEn from 'air-datepicker/locale/en';
import { createFocusTrap } from 'focus-trap';
import EmblaCarousel from 'embla-carousel';
import './blog';
import { Fancybox } from '@fancyapps/ui';


// Add a toggleAriaExpanded method to the HTMLElement prototype

HTMLElement.prototype.toggleAriaExpanded = function(expanded = null) {
    if (expanded === null) {
        expanded = this.getAttribute('aria-expanded') !== 'true';
    }

    this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
};


// If the user has scrolled, add a user-has-scrolled class to the body using a reusable function

const header = document.querySelector('.header');

function handleScroll() {
    const headerHeight = header.getBoundingClientRect().height;

    if (window.scrollY > headerHeight) {
        document.body.classList.add('user-has-scrolled');
    } else {
        document.body.classList.remove('user-has-scrolled');
    }
}

window.addEventListener('scroll', handleScroll);
handleScroll();


// Header desktop

const headerDesktopItemsWithSubmenu = document.querySelectorAll('.header-menu-desktop-list > li.menu-item-has-children');

function closeSubmenu(submenu, subSubmenuToggles = []) {
    submenu.classList.remove('visible');

    subSubmenuToggles.forEach(toggle => {
        toggle.toggleAriaExpanded(false);
        toggle.classList.remove('active');
        toggle.nextElementSibling?.classList.remove('visible');
    });
}

headerDesktopItemsWithSubmenu.forEach(item => {
    const submenu = item.querySelector('.sub-menu');
    const links = submenu.querySelectorAll('a');
    const subSubmenuToggles = submenu.querySelectorAll('button');

    subSubmenuToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            toggle.toggleAriaExpanded();
            toggle.classList.toggle('active');
            toggle.nextElementSibling?.classList.toggle('visible');
        }
    )});

    item.addEventListener('mouseleave', (event) => {
        closeSubmenu(submenu, subSubmenuToggles);
    });

    item.addEventListener('focusin', () => {
        submenu.classList.add('visible');
    });

    item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) {
            closeSubmenu(submenu, subSubmenuToggles);
        }
    });

    links.forEach(link => {
        link.addEventListener('click', () => {
            closeSubmenu(submenu, subSubmenuToggles);
        });
    });
});


// Mobile menu

const headerMobileToggle = document.querySelector('.header-mobile-toggle');
const headerMobile = document.querySelector('.header-mobile');
const headerMobileClose = headerMobile.querySelector('.header-mobile-close');
const headerMobileSearch = headerMobile.querySelector('.header-mobile-search');
const headerMobileBack = headerMobile.querySelector('.header-mobile-back');
const headerMobileBackLabel = headerMobileBack.querySelector('.header-mobile-back-label');
const headerMobileBackLabelText = headerMobileBackLabel.textContent;
const headerMobileMainInner = headerMobile.querySelector('.header-mobile-main-inner');
const headerMobileSubmenuToggles = headerMobile.querySelectorAll('.header-mobile-menu .menu-item-has-children > button');
const headerMobileFocusTrap = createFocusTrap(headerMobile);

let currentSubmenu = null;
let currentLevel = 0;

function openMobileMenu() {
    document.body.classList.add('header-mobile-open');
    headerMobileToggle.toggleAriaExpanded(true);
    headerMobileClose.toggleAriaExpanded(true);
    headerMobileClose.focus();
    closeSearch();

    window.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            closeMobileMenu();
        }
    }, { once: true });

    headerMobileFocusTrap.activate();
}

function closeMobileMenu() {
    document.body.classList.remove('header-mobile-open');
    headerMobileToggle.toggleAriaExpanded(false);
    headerMobileClose.toggleAriaExpanded(false);
    headerMobileFocusTrap.deactivate();

    currentSubmenu?.classList.remove('visible');
    currentSubmenu = null;
    currentLevel = 0;

    headerMobileMainInner.removeAttribute('style');
    updateSearchAndBackButtons();
}

function updateSearchAndBackButtons() {
    if (currentLevel === 0) {
        headerMobileBack.classList.remove('visible');
        headerMobileSearch.classList.remove('hidden');
    } else {
        headerMobileBack.classList.add('visible');
        headerMobileSearch.classList.add('hidden');
    }
    
    if (currentLevel > 1) {
        headerMobileBackLabel.textContent = currentSubmenu.parentElement.querySelector('a').textContent;
    } else {
        headerMobileBackLabel.textContent = headerMobileBackLabelText;
    }
}

function handleSubmenuToggleClick(toggle) {
    toggle.toggleAriaExpanded(true);

    currentSubmenu = toggle.nextElementSibling;
    currentSubmenu.classList.add('visible');

    headerMobileMainInner.style.transform = `translateX(-${100 * ++currentLevel}%)`;

    updateSearchAndBackButtons();
}

function handleBackButtonClick() {
    currentSubmenu.classList.remove('visible');
    currentSubmenu.previousElementSibling.toggleAriaExpanded(false);
    currentSubmenu = currentSubmenu.closest('.sub-menu');

    headerMobileMainInner.style.transform = `translateX(-${100 * --currentLevel}%)`;

    updateSearchAndBackButtons();
}

headerMobileToggle.addEventListener('click', openMobileMenu);
headerMobileClose.addEventListener('click', closeMobileMenu);
headerMobileBack.addEventListener('click', handleBackButtonClick);

headerMobileSubmenuToggles.forEach(toggle => {
    toggle.addEventListener('click', () => handleSubmenuToggleClick(toggle));
});


// Search

// const headerSearchToggles = document.querySelectorAll('.header-search-toggle, .header-mobile-search');
// const headerSearch = document.querySelector('.header-search');
// const headerSearchClose = headerSearch.querySelector('.header-search-close');
// const headerSearchInput = headerSearch.querySelector('.header-search-input');
// const headerSearchSuggestions = headerSearch.querySelectorAll('.header-search-suggestion');

// const searchFocusTrap = createFocusTrap(headerSearch, {
//     escapeDeactivates: e => {
//         closeSearch();
//         return true;
//     }
// });

// function openSearch() {
//     document.body.classList.add('search-open');
//     headerSearchToggles.forEach(toggle => toggle.toggleAriaExpanded(true));
//     headerSearchClose.toggleAriaExpanded(true);
//     searchFocusTrap.activate();
//     closeMobileMenu();
// }

// function closeSearch() {
//     document.body.classList.remove('search-open');
//     headerSearchToggles.forEach(toggle => toggle.toggleAriaExpanded(false));
//     headerSearchClose.toggleAriaExpanded(false);
//     headerSearchToggles[0].focus();
//     searchFocusTrap.deactivate();
// }

// headerSearchToggles.forEach(toggle => {
//     toggle.addEventListener('click', openSearch);
// });

// headerSearchClose.addEventListener('click', closeSearch);

// headerSearchSuggestions.forEach(suggestion => {
//     suggestion.addEventListener('click', () => {
//         headerSearchInput.value = suggestion.textContent;
//         headerSearch.submit();
//     });
// });


// Overview slider blocks

const overviewSliders = document.querySelectorAll('.overview-slider-outer:not(.blog-slider-viewport)');

overviewSliders.forEach(container => {
    const slider = EmblaCarousel(container, { align: 'start' });
});


// Gallery sliders

const gallerySliders = document.querySelectorAll('.gallery-slider-outer');

gallerySliders.forEach(container => { 
    const slides = container.querySelectorAll('.gallery-slide');

    if (slides.length > 1) {
        const slider = EmblaCarousel(container, { dragFree: true });
    }
});


// Location share buttons

const locationShareToggle = document.querySelector('.location-share-toggle');
const locationShare = document.querySelector('.location-share');

locationShareToggle?.addEventListener('click', () => {
    setTimeout(() => {
        locationShare.classList.add('visible');
        locationShareToggle.remove();
    }, 200);
}, { once: true });


// Wizard blocks

// const wizardBlocks = document.querySelectorAll('.wizard');

// wizardBlocks.forEach(wizard => {
//     const dateInput = wizard.querySelector('.wizard-date-input');
//     const hiddenDateInput = wizard.querySelector('.wizard-hidden-date-input');

//     const datePicker = new AirDatepicker(dateInput, {
//         locale: document.body.dataset.locale === 'nl' ? localeNl : localeEn,
//         isMobile: window.matchMedia('(max-width: 768px)').matches,
//         range: true,
//         autoClose: true,
//         multipleDatesSeparator: ' - ',
//         dateFormat: 'dd-MM-yyyy',
//         onSelect: function({ date }) {
//             if (date.length === 2) {
//                 hiddenDateInput.value = date.map(date => date.toLocaleDateString('en-CA')).join('|');
//             } else {
//                 hiddenDateInput.value = date[0].toLocaleDateString('en-CA');
//             }
//         }
//     });
// });


// Single location more button

const locationContentMoreButton = document.querySelector('.location-content-more');

locationContentMoreButton?.addEventListener('click', () => {
    locationContentMoreButton.nextElementSibling.classList.add('visible');
    locationContentMoreButton.toggleAriaExpanded(true);
    locationContentMoreButton.style.display = 'none';
} );


// Fancybox

Fancybox.bind('[data-fancybox]');


// Select elements with dynamic width

const dynamicSelects = document.querySelectorAll('.dynamic-select');

function changeSelectWidth(select) {
    if (window.matchMedia('(max-width: 60em)').matches) {
        select.removeAttribute('style');
        return;
    }

    const ghostSelect = document.createElement('select');
    ghostSelect.className = select.className;

    const text = select.options[select.selectedIndex].text;
    const ghostOption = document.createElement("option");
    ghostOption.setAttribute("value", text);

    const textNode = document.createTextNode(text);
    ghostOption.appendChild(textNode);
    ghostSelect.appendChild(ghostOption);

    window.document.body.appendChild(ghostSelect);
    select.style.width = ghostSelect.offsetWidth + 'px';
    window.document.body.removeChild(ghostSelect);
}

dynamicSelects.forEach(select => {
    changeSelectWidth(select);
    select.addEventListener('change', () => changeSelectWidth(select));
    select.addEventListener('updateWidth', () => changeSelectWidth(select));
    window.addEventListener('resize', () => changeSelectWidth(select));
});


// Dialog toggles

const dialogToggles = document.querySelectorAll('[data-dialog]');
const dialogClosers = document.querySelectorAll('[data-dialog-close]');

dialogToggles.forEach(toggle => {
    const dialog = document.querySelector(toggle.dataset.dialog);

    toggle.addEventListener('click', () => {
        dialog.showModal();
        toggle.toggleAriaExpanded(true);
    });

    dialog.addEventListener('click', e => {
        if (e.target === dialog) {
            dialog.close();
        }
    });

    dialog.addEventListener('close', () => {
        toggle.toggleAriaExpanded(false);
    });
});

dialogClosers.forEach(closer => {
    closer.addEventListener('click', () => {
        closer.closest('dialog').close();
    });
});


// Room dialog scroll buttons

const roomDialogScrollButtons = document.querySelectorAll('.room-dialog-scroll');

roomDialogScrollButtons.forEach(button => {
    const dialog = button.closest('dialog');
    const content = dialog.querySelector('.room-dialog-content');

    button.addEventListener('click', () => {
        content.scrollIntoView({ behavior: 'smooth' });
    });
});


// Static maps

const staticMaps = document.querySelectorAll('.map-static');

const staticMapObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const image = entry.target.querySelector('.map-static-image');

        image.addEventListener('load', () => entry.target.classList.add('loaded'), { once: true });
        image.src = image.dataset.src;

        observer.unobserve(entry.target);
    });
});

staticMaps.forEach(map => staticMapObserver.observe(map));

